import type { RejectionReason as UploadRejectionReason } from 'components/upload/utils';

enum Step {
  CreateNewAccount = 'create-new-account',
  ConfirmEmailAddress = 'confirm-email-address',
  SelectCategory = 'select-category',
  UploadDocuments = 'upload-documents',
  ReviewAndFinish = 'review-and-finish',
}

type UIGender = 'female' | 'male' | 'transgender';

type AccountType = 'performer' | 'studio' | 'couple';
type CategoryType = 'nude' | 'non-nude' | undefined;
type FaceVisibilityType = 'show' | 'hide' | undefined;

type RejectionReason = UploadRejectionReason | 'NoIdDetected' | 'NoFaceDetected' | 'FileRejected';

type BackendStep =
  | 'streamlined-create-account'
  | 'email-confirmation'
  | 'streamlined-choose-category'
  | 'streamlined-upload-documents'
  | 'streamlined-service-agreement'
  | 'in-review'
  | null;

interface DocumentTypeOption {
  id: string;
  value: { id: string; defaultMessage: string };
}

interface ExtensionsType {
  accountType?: string | null;
}

type EmailValidationError = 'empty' | 'invalid' | 'taken' | 'disposable';

export {
  Step,
  type UIGender,
  type CategoryType,
  type FaceVisibilityType,
  type RejectionReason,
  type DocumentTypeOption,
  type AccountType,
  type BackendStep,
  type EmailValidationError,
  type ExtensionsType,
};
